<template>
  <div class="chat-view" style="background-color: #f8f9fa;">


    <div v-if="showLoader"
      style="position: fixed; inset: 0; z-index: 2000; display: flex; align-items: center; justify-content: center; background: rgba(255,255,255,0.4);">
      <v-progress-circular color="primary" indeterminate :size="89" :width="7"></v-progress-circular>
    </div>

    <!-- <v-alert v-if="showNotificationAlert" type="info" transition="slide-y-transition"
      color="linear-gradient(135deg, #f9f9f9, #ffffff)" icon="mdi-bell" density="compact" class="notification-alert">
      {{ $t('chat.enable-notification') }}
      <v-btn size="small" color="success" variant="tonal" class="ml-4" @click="handleEnableNotifications">{{
        $t('chat.yes') }}</v-btn>
      <v-btn size="small" color="error" variant="tonal" class="ml-4" @click="hideNotificationAlert">{{ $t('chat.no')
      }}</v-btn>
    </v-alert> -->

    <vue-advanced-chat :current-user-id="ownUser?.email" :messages="JSON.stringify(messages)"
      :messages-loaded="messagesLoaded" :show-footer="true" :show-send-icon="true" :show-audio="true"
      :single-room="true" :show-files="true" :show-add-room="false" :rooms="JSON.stringify(rooms)"
      :show-new-messages-divider="true" :show-reaction-emojis="true" :show-emojis="true"
      @send-message-reaction="sendMessageReaction" @send-message="sendMessage" @edit-message="editMessage"
      @delete-message="deleteMessage" :height="isAndroid && !isTablet ? '84dvh' : '93dvh'"></vue-advanced-chat>


  </div>
</template>
<script>
import { ref, defineComponent, onMounted } from 'vue'
import { Capacitor } from '@capacitor/core'

import { retrieveBlob, requestNotificationPermission, checkNotificationPermission } from '@/services/utils'
import { useRoute } from 'vue-router'
import { register } from 'vue-advanced-chat'
import lodash from 'lodash'
import user_avatar from '@/assets/General/user_avatar.png'
import user_avatar2 from '@/assets/General/user_avatar2.png'
import { getToolbarLogoImage } from '@/assets/Branding/branding.js'
import {
  getChatOfUser,
  getAllChats,
  postChatMessage,
  getChatById,
  deleteChatById,
  updateChatById
} from '@/controllers/BaseController'
import moment from 'moment'
import { getFunctions, httpsCallable } from 'firebase/functions'
import { initializeApp, getApps } from 'firebase/app'
import { loadConfig } from '@/configLoader'

register()

export default defineComponent({
  name: 'Chat',
  setup() {
    const logo = ref('')
        const isAndroid = Capacitor.getPlatform() === 'android'

    const showLoader = ref(false)
    const selectedUser = ref(null)
    const ownUser = ref(null)
    const messages = ref([])
    const messagesLoaded = ref(false)
    const route = useRoute()
    const rooms = ref([])
    const showNotificationAlert = ref(false)
    const apiChatItems = ref([])
    const selectedUserSub = ref(null)
    const isTablet = ref(false);

    const handleEnableNotifications = async () => {
      const permission = await requestNotificationPermission()
      if (permission === 'granted') console.log('Notification permissions granted.')
      hideNotificationAlert()
    }

    const hideNotificationAlert = () => {
      showNotificationAlert.value = false
    }

    const isDevEnv = () => {
      const platform = Capacitor.getPlatform()

      // ✅ Native platforms: use Capacitor.DEBUG
      if (platform === 'android' || platform === 'ios') {
        return !!Capacitor.DEBUG
      }

      // ✅ Web: check localhost or 192.168.*
      const hostname = typeof window !== 'undefined' ? window.location.hostname : ''
      return hostname.includes('localhost') || hostname.startsWith('192.168.')
    }


    const sendNotification = async (toUserSub, messageContent) => {
      try {
        console.log('🔔 Sending push notification to:', toUserSub)
        console.log('Is Dev Environment:', isDevEnv())
        if (!toUserSub) return

        const payload = {
          toUserId: toUserSub,
          title: '📩 New Message',
          body: messageContent,
          environment: isDevEnv() ? 'development' : 'production',

        }

        const response = await fetch('https://europe-west10-pia-pinestack-assist.cloudfunctions.net/sendDirectNotification', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(payload),
        })

        const data = await response.json()
        if (!response.ok) {
          throw new Error(data.error || 'Unknown error from sendDirectNotification')
        }

        console.log('✅ Notification sent:', data)
      } catch (err) {
        console.error('🚫 Error sending push notification:', err)
      }
    }


    const sendMessage = async content => {
      const message = content?.detail[0]
      const SelectedUser = JSON.parse(JSON.stringify(selectedUser.value))
      const OwnUser = JSON.parse(JSON.stringify(ownUser.value))
      const isReply = message?.replyMessage !== null

      const newMsg = {
        _id: Math.floor(1000 + Math.random() * 9000).toString(),
        content: message.content,
        senderId: OwnUser.email,
        replyMessage: isReply ? JSON.parse(JSON.stringify(message.replyMessage)) : null,
        username: OwnUser.title,
        avatar: user_avatar2,
        timestamp: new Date().toLocaleTimeString(),
        seen: true,
        disableReactions: true
      }

      messages.value.push(newMsg)

      try {
        await postChatMessage(SelectedUser?.profile?.id, message.content)

        if (selectedUserSub.value) {
          const nameOfUser =
            SelectedUser?.title ||
            (SelectedUser?.firstName && SelectedUser?.lastName
              ? `${SelectedUser.firstName} ${SelectedUser.lastName}`
              : SelectedUser?.email)

          console.log('📨 Sending notification from:', nameOfUser)

          await sendNotification(selectedUserSub.value, message.content, nameOfUser)
        }
      } catch (error) {
        console.error('Message sending or notification failed:', error)
      }
    }

    const sendMessageReaction = content => {
      const reaction = content?.detail[0]
      const OwnUser = JSON.parse(JSON.stringify(ownUser.value))
      const reactionMessage = reaction?.reaction?.unicode
      const Messages = JSON.parse(JSON.stringify(messages.value))
      const messageIndex = Messages.findIndex(m => m._id === reaction?.messageId)

      if (messageIndex !== -1) {
        Messages[messageIndex].reactions = Messages[messageIndex].reactions || {}
        Messages[messageIndex].reactions[reactionMessage] =
          Messages[messageIndex].reactions[reactionMessage] || []

        const idx = Messages[messageIndex].reactions[reactionMessage].indexOf(OwnUser.email)
        if (idx === -1) {
          Messages[messageIndex].reactions[reactionMessage].push(OwnUser.email)
        } else {
          Messages[messageIndex].reactions[reactionMessage].splice(idx, 1)
          if (Messages[messageIndex].reactions[reactionMessage].length === 0) {
            delete Messages[messageIndex].reactions[reactionMessage]
          }
        }
        messages.value = Messages
      }
    }

    const editMessage = async content => {
      try {
        const { messageId, newContent } = content.detail[0]
        const Messages = JSON.parse(JSON.stringify(messages.value))
        const messageIndex = Messages.findIndex(m => m._id === messageId)

        if (messageIndex !== -1) {
          Messages[messageIndex].content = newContent
          const chatId = Messages[messageIndex]._id
          const originalChat = lodash.find(apiChatItems.value, chat => chat.id === chatId)
          originalChat.message = newContent
          await updateChatById(chatId, originalChat)
          messages.value = Messages
        }
      } catch (err) {
        console.error('Message edit failed:', err)
      }
    }

    const deleteMessage = async content => {
      try {
        const { message } = content.detail[0]
        const Messages = JSON.parse(JSON.stringify(messages.value))
        const index = Messages.findIndex(m => m._id === message._id)
        if (index !== -1) {
          Messages[index].deleted = true
          await deleteChatById(message._id)
          messages.value = Messages
        }
      } catch (err) {
        console.error('Message deletion failed:', err)
      }
    }

    const getUserSubByEmailSafe = async (email) => {
      const region = 'europe-west10'
      const url = `https://${region}-pia-pinestack-assist.cloudfunctions.net/getUserSubByEmail`

      try {
        const res = await fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email })
        })

        if (!res.ok) {
          const text = await res.text()
          console.warn('⚠️ Error response from sub lookup:', text)
          return null
        }

        const data = await res.json()
        return data?.sub || null
      } catch (err) {
        console.error('❌ Sub lookup failed:', err)
        return null
      }
    }

    onMounted(async () => {
      try {
        showLoader.value = true
        logo.value = await getToolbarLogoImage()
        isTablet.value = Math.min(window.screen.width, window.screen.height) >= 600;
        const config = await loadConfig()
        if (!getApps().length) initializeApp(config.firebaseConfig)

        const user = await retrieveBlob('selectedUser')
        const own = await retrieveBlob('ownUser')
        selectedUser.value = user
        ownUser.value = own

        selectedUserSub.value = await getUserSubByEmailSafe(user?.email)

        const chats = await getAllChats()
        const chat = chats.find(c => c.userProfileId2 === user?.profile?.id || c.userProfileId1 === user?.profile?.id)

        if (chat) {
          const chatData = await getChatById(chat.id)
          const items = chatData.chatItems.items
          apiChatItems.value = items

          messages.value = items.map(item => ({
            _id: item.id,
            indexId: item.version,
            content: item.message,
            senderId: item.creatorProfile.id === user?.profile?.id ? user?.email : own?.email,
            username: item.creatorProfile.id === own?.profile?.id ? own.title : user.title,
            avatar: item.creatorProfile.id === own?.profile?.id ? own.prependAvatar : user.prependAvatar,
            date: moment(item.createdAt).format('YYYY-MM-DD'),
            timestamp: moment(item.createdAt).format('hh:mm:ss A'),
            system: false,
            saved: true,
            distributed: true,
            seen: true,
            deleted: false,
            failure: false,
            disableActions: false,
            disableReactions: true
          }))
        }

        rooms.value = [
          {
            roomId: '1',
            roomName: user?.title,
            avatar: user?.prependAvatar,
            users: [
              { _id: user?.email, username: user?.title, avatar: user?.prependAvatar },
              { _id: own?.email, username: own?.title, avatar: own?.prependAvatar }
            ],
            typingUsers: [own?.email]
          }
        ]

        setTimeout(async () => {
          if ((await checkNotificationPermission()) !== 'granted') {
            showNotificationAlert.value = true
          }
        }, 3000)

        messagesLoaded.value = true
      } catch (err) {
        console.error('Chat setup failed:', err)
      } finally {
        showLoader.value = false
      }
    })

    return {
      logo,
      showLoader,
      selectedUser,
      ownUser,
      messages,
      messagesLoaded,
      sendMessage,
      sendMessageReaction,
      editMessage,
      deleteMessage,
      route,
      rooms,
      showNotificationAlert,
      handleEnableNotifications,
      hideNotificationAlert,
      isDevEnv,
      isAndroid,
      isTablet
    }
  }
})
</script>



<style scoped>
.chat-view {}

.vac-room-header.vac-app-border-b {
  display: none !important;
  height: 0 !important;
  padding: 0 !important;
  margin: 0 !important;
  border: none !important;
}

.custom-toolbar {
  background-color: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(10px);
  color: #333333;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  padding: 8px 16px;
}

@supports (-webkit-touch-callout: none) {
  .custom-toolbar {
    position: sticky;
    top: 0;
    z-index: 1000;
  }
}

.notification-alert {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;
  width: 70%;
  padding: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  /* Subtle shadow */
  border-radius: 8px;
  animation: slideDown 0.4s ease-in-out;
  display: flex;
  justify-content: start;
  align-items: start;
}

@keyframes slideDown {
  0% {
    top: -50px;
    opacity: 0;
  }

  100% {
    top: 10px;
    opacity: 1;
  }
}

.alert-content {
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
}

.alert-text {
  font-size: 1.2rem;
  font-weight: 500;
  color: #1a237e;
}

.custom-toolbar-title {
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
  font-size: 1.5rem;
  color: #333333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: calc(100% - 120px);
}

.toolbar-icon {
  height: 30px;
  align-self: center;
  margin-left: 1rem;
}

.chat-container {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 64px);
  /* Adjust according to your toolbar height */
}
</style>
<!--
Chat Component

This component provides a chat interface for users to communicate with each other. The main features include sending, editing, and deleting messages, as well as reacting to messages with emojis. The chat interface is designed to be user-friendly and responsive, ensuring a smooth user experience.

Functionalities:
1. Loader: Displays a loading spinner when data is being fetched or processed.
2. Notification Alert: Prompts users to enable notifications for the chat. Users can choose to enable or disable notifications by clicking the respective buttons.
3. Chat Interface: Displays the chat messages between users. Users can send new messages, edit existing messages, and delete messages. The chat interface also supports reactions to messages, although reactions are disabled in this implementation.
4. Message Input: Users can type and send messages using the input field at the bottom of the chat interface. The send button allows users to send their messages.
5. Visual Feedback: The component provides visual feedback for various actions. For example, when a message is successfully sent, it appears in the chat interface. If there is an error while sending a message, an error message is logged in the console.

Dynamic Behaviors:
1. Notification Permission: When the component is mounted, it checks if the user has granted notification permissions. If not, a notification alert is displayed, prompting the user to enable notifications.
2. Message Reactions: Users can react to messages by clicking on the reaction icons. The reactions are updated in real-time and displayed next to the respective messages.
3. Message Sending: When a user sends a message, it is added to the chat interface and sent to the server. If the message is successfully sent, it appears in the chat interface. If there is an error, an error message is logged in the console.
4. Message Editing: Users can edit their messages by clicking on the edit icon. The edited message is updated in the chat interface and sent to the server.
5. Message Deletion: Users can delete their messages by clicking on the delete icon. The deleted message is marked as deleted in the chat interface and removed from the server.

Visual Feedback:
1. Loader: Displays a loading spinner when data is being fetched or processed.
2. Notification Alert: Displays a notification alert at the top of the chat interface, prompting users to enable notifications.
3. Message Reactions: Displays reaction icons next to messages, indicating the reactions from users.
4. Message Sending: Displays the sent message in the chat interface. If there is an error, an error message is logged in the console.
5. Message Editing: Updates the edited message in the chat interface. If there is an error, an error message is logged in the console.
6. Message Deletion: Marks the deleted message as deleted in the chat interface. If there is an error, an error message is logged in the console.

Overall, this chat component provides a comprehensive and interactive chat experience for users, allowing them to communicate effectively and efficiently within the app.
-->
